// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { circle16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-circle': IconCircle;
    }
}

/**
 * The icon component for the 'circle' icon
 */
export class IconCircle extends Icon {
    public constructor() {
        super(circle16X16);
    }
}

registerIcon('icon-circle', IconCircle);
export const iconCircleTag = 'nimble-icon-circle';
